import {connect} from 'react-redux'
import {
  setRefundItems,
  issueRefundRequest,
  askSetQuantity,
  confirmSetQuantity,
  cancelSetQuantity,
  cancelRefundBreakdown
} from 'actions/reports/transactions'
import {Modal} from 'react-bootstrap'
import styles from './TransactionRefundModal.css'
import moment from 'moment'
import Gratuity from 'components/receipt/refunds/RefundBreakdownModal/Gratuity'
import Tax from 'components/receipt/refunds/RefundBreakdownModal/Tax'
import Discount from 'components/receipt/refunds/RefundBreakdownModal/Discount'
import RewardRedemption from 'components/receipt/refunds/RefundBreakdownModal/RewardRedemption'
import AmountToRefund from 'components/receipt/refunds/AmountToRefund'
import RefundReason from 'components/receipt/refunds/RefundReason'
import Item from 'components/receipt/refunds/RefundBreakdownModal/Item'
import ModalHeader from 'components/Modal/ModalHeader'
import * as mpReportsTransactions from 'mixpanel/reports/transactions'
import {formValueSelector} from 'redux-form'

class TransactionRefundModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      reasonForRefund: '',
      otherReasonForRefund: ''
    }
  }

  render () {
    let {openRefundBreakdownModal, refundBreakdown, transactionDetail, openSetQuantityModal} = this.props.data.reports.transactions
    return ((transactionDetail !== null) && <Modal onHide={this._onHide} show={openRefundBreakdownModal} bsClass='full-height-modal margin-top-modal modal'>
      <ModalHeader title='Issue Refund' />
      <Modal.Body bsClass={`${styles['modal-body']} modal-body`}>
        <AmountToRefund calculateAmountToRefund={this._calculateAmountToRefund} />
        <Item
          isChecked={this._isChecked}
          isSelectedAll={this._isSelectedAll}
          isRefunded={this._isRefunded}
          canBeRefunded={this._canBeRefunded}
          canSelectAll={() => true}
          onClickCheck={this._onClickCheck}
          onClickSelectAll={this._onClickSelectAll}
          onClickDeselectAll={this._onClickDeselectAll}
          onClickIncreaseQty={this._onClickIncreaseQty}
          onClickDecreaseQty={this._onClickDecreaseQty}
          onChangeInputAmountRefunded={this._onChangeInputAmountRefunded}
          refundItems={refundBreakdown.refundItems}
          calculateItemPrice={this._calculateItemPrice}
          onAskSetQtyModal={this._onAskSetQtyModal}
          onConfirmSetQtyModal={this._onConfirmSetQtyModal}
          onCancelSetQtyModal={this._onCancelSetQtyModal}
          openSetQtyModal={openSetQuantityModal}
          showCheckbox
            />
        <Discount
          paymentDiscounts={transactionDetail.payment_discounts}
          calculateDiscount={this._calculateDiscount}
          />
        <RewardRedemption
          redeemReward={this._getRewardName()}
          redeemAmount={this._calculateRedeemAmount()}
         />
        <Gratuity
          includeGratuityTax={transactionDetail.include_gratuity_tax}
          paymentGratuities={transactionDetail.payment_gratuities}
          calculateGratuity={this._calculateGratuity}
          />
        <Tax
          includeGratuityTax={transactionDetail.include_gratuity_tax}
          paymentTaxes={transactionDetail.payment_taxes}
          calculateTax={this._calculateTax}
          />
        <RefundReason
          labelReason='Reason for Refund'
          onChangeOtherReasonForRefund={this._onChangeOtherReasonForRefund}
          onChangeReasonForRefund={this._onChangeReasonForRefund}
          />
      </Modal.Body>
      <Modal.Footer>
        <div className='pull-left'>
          <button type='button' className='btn btn-default' onClick={this._onHide}>Cancel</button>
        </div>
        <div>
          <button
            type='button'
            className='btn btn-primary pull-right'
            onClick={this._onClickIssueRefund}
            disabled={!this._isIssueRefundButtonEnabled()}
          >
              Issue Refund
          </button>
        </div>
      </Modal.Footer>
      </Modal>)
  }

  _getRewardName = () => {
    const {transactionDetail} = this.props.data.reports.transactions
    return transactionDetail.loyalty && transactionDetail.loyalty.type.toLowerCase() === 'redemption' ? transactionDetail.loyalty.redemption.reward : ''
  }

  _onHide = () => {
    const {transactionDetail} = this.props.data.reports.transactions
    this.setState({reasonForRefund: null})
    this.props.dispatch(cancelRefundBreakdown(transactionDetail))
  }

  _onChangeReasonForRefund = (value) => {
    this.setState({reasonForRefund: value})
  }

  _onChangeOtherReasonForRefund = (value) => {
    this.setState({otherReasonForRefund: value})
  }

  _isIssueRefundButtonEnabled = () => {
    // if all items are refunded disable it
    let hasItemRefunded = false
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    refundItems.forEach((refundItem) => {
      hasItemRefunded = (hasItemRefunded || refundItem.isRefunded)
    })

    if (this.state.reasonForRefund === 'Other') {
      //! ! --> boolean not empty
      return (hasItemRefunded && !!this.state.otherReasonForRefund)
    } else {
      //! ! --> boolean not empty
      return (hasItemRefunded && !!this.state.reasonForRefund)
    }
  }

  _onClickIssueRefund = () => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let {transactionDetail} = this.props.data.reports.transactions
    // construct items
    let itemCallbacks = []

    refundItems.forEach((refundItem) => {
      // items - discounts
      let itemDiscounts = refundItem.discounts.map((discount) => {
        return {
          discount_id: discount.discount_id,
          discount_name: discount.discount_name,
          discount_type: discount.discount_type,
          discount_cash: discount.discount_cash,
          discount_percentage: discount.discount_percentage,
          discount_amount: -refundItem.refundAmount * discount.discount_per_item
        }
      })
      // items - modifiers
      let itemModifiers = refundItem.modifiers.map((modifier) => {
        modifier.gross_sales = -refundItem.refundAmount * modifier.gross_per_item
        modifier.net_sales = -refundItem.refundAmount * modifier.net_per_item
        modifier.discount_amount = -refundItem.refundAmount * modifier.discount_per_item
        modifier.redeem_amount = -refundItem.refundAmount * modifier.redeem_per_item
        modifier.modifier_discounts = modifier.modifier_discounts.map((modifierDiscount) => {
          modifierDiscount.discount_amount = -refundItem.refundAmount * modifierDiscount.discount_per_item
          return modifierDiscount
        })
        return modifier
      })

      if (refundItem.isRefunded) {
        itemCallbacks.push({
          category_id: refundItem.categoryId,
          category_name: refundItem.categoryName,
          client_price: refundItem.pricePerItem,
          discount_amount: -refundItem.refundAmount * refundItem.discountPerItem,
          redeem_amount: -refundItem.refundAmount * refundItem.redemptionPerItem,
          discounts: itemDiscounts,
          gratuity: -refundItem.refundAmount * refundItem.gratuityPerItem,
          gross_sales: -refundItem.refundAmount * refundItem.grossPerItem,
          item_id: refundItem.itemId,
          item_image: refundItem.itemImage,
          item_name: refundItem.itemName,
          item_variant_id: refundItem.itemVariantId,
          item_variant_name: refundItem.itemVariantName,
          item_variant_sku: refundItem.itemVariantSku,
          modifiers: itemModifiers,
          net_sales: -refundItem.refundAmount * refundItem.netPerItem,
          parent_checkout_id: refundItem.parentCheckoutId,
          position: refundItem.position,
          quantity: -refundItem.refundAmount,
          tax: -refundItem.refundAmount * refundItem.taxPerItem,
          track_stock: refundItem.trackStock
        })
      }
    })
    // construct discounts
    let discounts = []
    transactionDetail.payment_discounts.forEach((discount) => {
      discounts.push({
        discount_amount: -this._calculateDiscount(discount.discount_id),
        discount_cash: discount.discount_cash,
        discount_id: discount.discount_id,
        discount_name: discount.discount_name,
        discount_type: discount.discount_type
      })
    })

    // construct gratuities
    let gratuities = []
    transactionDetail.payment_gratuities.forEach((gratuity) => {
      gratuities.push({
        gratuity_amount: -this._calculateGratuity(gratuity.id),
        gratuity_id: gratuity.gratuity_id,
        gratuity_name: gratuity.name,
        gratuity_percentage: gratuity.amount
      })
    })

    // construct taxes
    let taxes = []
    transactionDetail.payment_taxes.forEach((tax) => {
      taxes.push({
        tax_amount: -this._calculateTax(tax.id),
        tax_id: tax.tax_id,
        tax_name: tax.name,
        tax_percentage: tax.amount,
        taxable_amount: -this._calculateTaxable(tax.id)
      })
    })

    let totalDiscount = 0
    let totalGratuity = 0
    let totalGrossSales = 0
    let totalNetSales = 0
    let totalTax = 0
    let totalRedeemAmount = 0

    refundItems.forEach((refundItem) => {
      if (refundItem.isRefunded) {
        totalDiscount += refundItem.refundAmount * refundItem.discountPerItem
        totalGratuity += refundItem.refundAmount * refundItem.gratuityPerItem
        totalGrossSales += refundItem.refundAmount * refundItem.grossPerItem
        totalNetSales += refundItem.refundAmount * refundItem.netPerItem
        totalTax += refundItem.refundAmount * refundItem.taxPerItem
        totalRedeemAmount += refundItem.refundAmount * refundItem.redemptionPerItem
      }
    })

    let totalCollected = totalNetSales + totalGratuity + totalTax

    let loyalty = null
    if (transactionDetail.loyalty) {
      loyalty = {
        new_earned_points: 0,
        program_id: transactionDetail.loyalty.program_id,
        member_since: transactionDetail.loyalty.member_since,
        earning_rule: transactionDetail.loyalty.earning_rule,
        member_id: transactionDetail.loyalty.member_id,
        member_uniq_id: transactionDetail.loyalty.member_uniq_id,
        member_guid: transactionDetail.loyalty.member_guid
      }

      if (transactionDetail.loyalty.type.toUpperCase() === 'REDEMPTION') {
        let {redemption} = transactionDetail.loyalty
        loyalty.redemption = {
          'redeem_points': redemption.redeem_points,
          'redeem_amount': -totalRedeemAmount,
          'reward_type': redemption.reward_type,
          'reward_id': redemption.reward_id,
          'reward': redemption.reward,
          'discount': redemption.discount,
          'discount_type': redemption.discount_type
        }
      }

      if (transactionDetail.loyalty.type.toUpperCase() === 'EARNING') {
        let parentTotalCollected = transactionDetail.total_collected
        let parentTotalRefund = transactionDetail.total_refund
        let earningRule = transactionDetail.loyalty.earning_rule
        let refundedPoint = transactionDetail.payment_refunds
          .map((e) => { return e.loyalty ? e.loyalty.point_correction : 0 })
          .reduce((first, second) => first + second, 0)

        let currentAvailablePoint = transactionDetail.loyalty.new_earned_points - refundedPoint

        let finalCustomerSpendingAmount = parentTotalCollected - parentTotalRefund - totalCollected
        loyalty.new_earned_points = parseInt(finalCustomerSpendingAmount / earningRule.amount) * earningRule.point - currentAvailablePoint
      }
    }

    let data = {
      amount: Math.round(transactionDetail.total_collected - transactionDetail.total_refund),
      client_created_at: moment().format(),
      custom_reason: this.state.reasonForRefund === 'Other' ? this.state.otherReasonForRefund : '',
      discounts: discounts,
      gratuities: gratuities,
      is_refund_transaction: true,
      items: itemCallbacks,
      payment_id: transactionDetail.id,
      reason: this.state.reasonForRefund !== 'Other' ? this.state.reasonForRefund : this.state.otherReasonForRefund,
      refund_amount: totalNetSales,
      taxes: taxes,
      loyalty: loyalty,
      total_collected: -totalCollected,
      total_discount: -totalDiscount,
      total_redeem_amount: -totalRedeemAmount,
      total_gratuity: -totalGratuity,
      total_gross_sales: -totalGrossSales,
      total_net_sales: -totalNetSales,
      total_tax: -totalTax
    }
    const maxAmountToRefund = Math.round(transactionDetail.total_collected - transactionDetail.total_refund)
    const amountToRefund = totalNetSales
    const {search: {outlet, date: {startDate, endDate}}} = this.props
    mpReportsTransactions.reportsTransactionRefund({
      amount: amountToRefund,
      isFullRefund: Math.abs(amountToRefund - maxAmountToRefund) < 0.0001,
      outletIds: outlet,
      startDate: startDate,
      endDate: endDate
    })

    this.props.dispatch(issueRefundRequest({refund: data}))
  }

  _isSelectedAll = () => {
    let isRefundedAll = true
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    refundItems.forEach(refundItem => {
      if (refundItem.maxQuantity > 0 && !refundItem.isRefunded) {
        isRefundedAll = false
      }
    })
    return isRefundedAll
  }

  _onClickSelectAll = () => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    refundItems.forEach(refundItem => {
      if (refundItem.maxQuantity > 0) { // can be refunded if only max_qty > 0
        refundItem.isRefunded = true
      }
    })
    this.props.dispatch(setRefundItems(refundItems))
  }

  _onClickDeselectAll = () => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    refundItems.forEach(refundItem => {
      refundItem.isRefunded = false
    })
    this.props.dispatch(setRefundItems(refundItems))
  }

  _onClickCheck = (idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    refundItems[idx].isRefunded = !refundItems[idx].isRefunded
    this.props.dispatch(setRefundItems(refundItems))
  }

  /**
   * @param {int} idx index of refundItems in array of refundBreakdown
   * @private
   */
  _onClickDecreaseQty = (idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    if (refundItems[idx].refundAmount > 1) {
      refundItems[idx].refundAmount -= 1
      this.props.dispatch(setRefundItems(refundItems))
    }
  }

  /**
   * @param {int} idx index of refundItems in array of refundBreakdown
   * @private
   */
  _onClickIncreaseQty = (idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    if (refundItems[idx].refundAmount < refundItems[idx].maxQuantity) {
      refundItems[idx].refundAmount += 1
      this.props.dispatch(setRefundItems(refundItems))
    }
  }

  /**
   *
   * @param idx
   * @private
   */
  _isChecked = (idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    return refundItems[idx].isRefunded
  }

  _canBeRefunded = (idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    return (
      (
        (!refundItems[idx].refundAmount && this._calculateItemPrice(idx) === 0) ||
        (this._calculateItemPrice(idx) > 0 && refundItems[idx].refundAmount > 0)
      ) &&
        refundItems[idx].maxQuantity > 0
    )
  }

  _isRefunded = (idx) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    return refundItems[idx].isRefunded
  }

  _onChangeInputAmountRefunded = (idx, value) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let maxQuantity = refundItems[idx].maxQuantity
    if (parseInt(value)) {
      if (value > maxQuantity) {
        refundItems[idx].refundAmount = parseInt(maxQuantity)
      } else {
        refundItems[idx].refundAmount = parseInt(value)
      }
    } else {
      refundItems[idx].refundAmount = refundItems[idx].maxQuantity
    }
    this.props.dispatch(setRefundItems(refundItems))
  }

  _onAskSetQtyModal = (idx, refundAmount) => {
    this.props.dispatch(askSetQuantity(idx, refundAmount))
  };

  _onCancelSetQtyModal = () => {
    this.props.dispatch(cancelSetQuantity())
  }

  _onConfirmSetQtyModal = (idx, value) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let maxQuantity = refundItems[idx].maxQuantity
    if (value) {
      if (value > maxQuantity) {
        refundItems[idx].refundAmount = maxQuantity
      } else {
        refundItems[idx].refundAmount = value
      }
    } else {
      refundItems[idx].refundAmount = 0
    }
    this.props.dispatch(confirmSetQuantity(refundItems))
  };

  /**********************************************************************
   * Calculation
   **********************************************************************/

  _calculateAmountToRefund = () => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let {transactionDetail} = this.props.data.reports.transactions
    let totalGratuities = 0
    let totalTaxes = 0
    let totalDiscounts = 0
    let totalItems = 0
    let totalRedeemAmount = 0

    refundItems.forEach((refundItem, idx) => {
      if (refundItem.isRefunded) {
        totalItems += this._calculateItemPrice(idx)
      }
    })

    transactionDetail.payment_gratuities.forEach((gratuity) => {
      totalGratuities += this._calculateGratuity(gratuity.id)
    })

    transactionDetail.payment_discounts.forEach((discount) => {
      totalDiscounts += this._calculateDiscount(discount.discount_id)
    })

    transactionDetail.payment_taxes.forEach((tax) => {
      totalTaxes += this._calculateTax(tax.id)
    })

    totalRedeemAmount = this._calculateRedeemAmount()
    return totalItems - totalDiscounts - totalRedeemAmount + totalGratuities + totalTaxes
  }

  _calculateItemPrice = (itemId) => {
    let totalDiscounts = 0
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let refundItem = refundItems[itemId]
    refundItem.discounts.forEach((discount) => {
      if (discount.discount_type === 'percentage') {
        totalDiscounts += parseFloat(discount.discount_percentage)
      }
    })
    let itemPrice
    // if all refunded
    if (!refundItem.maxQuantity) {
      itemPrice = (1 - totalDiscounts / 100.0) * (refundItem.pricePerItem)
    } else {
      itemPrice = (1 - totalDiscounts / 100.0) * (refundItem.refundAmount * refundItem.pricePerItem)
    }
    if (itemPrice < 0) itemPrice = 0
    return itemPrice
  }

  _calculateDiscount = (discountId) => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let total = 0
    refundItems.forEach((refundItem) => {
      if (refundItem.isRefunded) {
        refundItem.discounts.forEach(discount => {
          if (discount.discount_id === discountId) {
            total += refundItem.refundAmount * discount.discount_per_item
          }
        })
      }
    })
    return total
  }

  _calculateRedeemAmount = () => {
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let totalAmount = refundItems.filter(item => item.isRefunded).reduce((total, item) => {
      return total + (item.redemptionPerItem * item.refundAmount)
    }, 0)
    return totalAmount
  }

  _calculateGratuity = (gratuityId) => {
    let {transactionDetail} = this.props.data.reports.transactions
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let total = 0
    transactionDetail.payment_gratuities.forEach((gratuity) => {
      if (gratuity.id === gratuityId) {
        refundItems.forEach((refundItem) => {
          if (refundItem.isRefunded) {
            total += (gratuity.amount / 100) * refundItem.refundAmount * (refundItem.netPerItem)
          }
        })
      }
    })
    return total
  }

  _calculateTax = (taxId) => {
    let {transactionDetail} = this.props.data.reports.transactions
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let total = 0
    transactionDetail.payment_taxes.forEach((tax) => {
      if (tax.id === taxId) {
        refundItems.forEach((refundItem) => {
          if (refundItem.isRefunded) {
            total += (tax.amount / 100.0) * refundItem.refundAmount * (refundItem.netPerItem + refundItem.gratuityPerItem)
          }
        })
      }
    })
    return total
  }

  _calculateTaxable = (taxId) => {
    let {transactionDetail} = this.props.data.reports.transactions
    let {refundItems} = this.props.data.reports.transactions.refundBreakdown
    let total = 0
    transactionDetail.payment_taxes.forEach((tax) => {
      if (tax.id === taxId) {
        refundItems.forEach((refundItem) => {
          if (refundItem.isRefunded) {
            total += refundItem.refundAmount * (refundItem.netPerItem + refundItem.gratuityPerItem)
          }
        })
      }
    })
    return total
  }

  /**********************************************************************
   * End of Calculation
   **********************************************************************/
}

TransactionRefundModal.propTypes = {
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date')
    },
    data: {
      reports: {
        transactions: state.reports.transactions
      }
    }
  }
}

export default connect(mapStateToProps)(TransactionRefundModal)



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/TransactionRefundModal/TransactionRefundModal.js